
export const regionMapping = {
  'costa brava': { country: 'Spanje', region: 'Costa Brava' },
  'costa del sol': { country: 'Spanje', region: 'Costa del Sol' },
  'costa blanca': { country: 'Spanje', region: 'Costa Blanca' },
  'mallorca': { country: 'Spanje', region: 'Mallorca' },
  'ibiza': { country: 'Spanje', region: 'Ibiza' },
  'tenerife': { country: 'Spanje', region: 'Tenerife' },
  'gran canaria': { country: 'Spanje', region: 'Gran Canaria' },
  'toscane': { country: 'Italië', region: 'Toscane' },
  'toscana': { country: 'Italië', region: 'Toscane' },
  'sicilië': { country: 'Italië', region: 'Sicilië' },
  'sardinië': { country: 'Italië', region: 'Sardinië' },
  'kreta': { country: 'Griekenland', region: 'Kreta' },
  'rhodos': { country: 'Griekenland', region: 'Rhodos' },
  'kos': { country: 'Griekenland', region: 'Kos' },
  'zakynthos': { country: 'Griekenland', region: 'Zakynthos' },
  'santorini': { country: 'Griekenland', region: 'Santorini' },
  'mykonos': { country: 'Griekenland', region: 'Mykonos' },
  'algarve': { country: 'Portugal', region: 'Algarve' },
  'madeira': { country: 'Portugal', region: 'Madeira' },
  'hurghada': { country: 'Egypte', region: 'Hurghada' },
  'sharm el sheikh': { country: 'Egypte', region: 'Sharm El Sheikh' },
  'marsa alam': { country: 'Egypte', region: 'Marsa Alam' },
  'provence': { country: 'Frankrijk', region: 'Provence' },
  'côte d\'azur': { country: 'Frankrijk', region: 'Côte d\'Azur' },
  // Dubai en UAE regio's toevoegen
  'dubai': { country: 'Verenigde Arabische Emiraten', region: 'Dubai' },
  'abu dhabi': { country: 'Verenigde Arabische Emiraten', region: 'Abu Dhabi' },
  'sharjah': { country: 'Verenigde Arabische Emiraten', region: 'Sharjah' },
  'ras al khaimah': { country: 'Verenigde Arabische Emiraten', region: 'Ras Al Khaimah' },
  // Asian regions
  'phuket': { country: 'Thailand', region: 'Phuket' },
  'koh samui': { country: 'Thailand', region: 'Koh Samui' },
  'krabi': { country: 'Thailand', region: 'Krabi' },
  'pattaya': { country: 'Thailand', region: 'Pattaya' },
  'koh phi phi': { country: 'Thailand', region: 'Koh Phi Phi' },
  'chiang mai': { country: 'Thailand', region: 'Chiang Mai' },
  'bali': { country: 'Indonesië', region: 'Bali' },
  'lombok': { country: 'Indonesië', region: 'Lombok' },
  'java': { country: 'Indonesië', region: 'Java' },
  'sumatra': { country: 'Indonesië', region: 'Sumatra' },
  'langkawi': { country: 'Maleisië', region: 'Langkawi' },
  'penang': { country: 'Maleisië', region: 'Penang' },
  'hoi an': { country: 'Vietnam', region: 'Hoi An' },
  'halong bay': { country: 'Vietnam', region: 'Halong Bay' },
  'phu quoc': { country: 'Vietnam', region: 'Phu Quoc' },
  'siem reap': { country: 'Cambodja', region: 'Siem Reap' },
  'goa': { country: 'India', region: 'Goa' },
  'kerala': { country: 'India', region: 'Kerala' },
  'rajasthan': { country: 'India', region: 'Rajasthan' },
  // American regions
  'yucatan': { country: 'Mexico', region: 'Yucatan' },
  'riviera maya': { country: 'Mexico', region: 'Riviera Maya' },
  'cancun': { country: 'Mexico', region: 'Cancun' },
  'playa del carmen': { country: 'Mexico', region: 'Playa del Carmen' },
  'los cabos': { country: 'Mexico', region: 'Los Cabos' },
  'puerto vallarta': { country: 'Mexico', region: 'Puerto Vallarta' },
  'california': { country: 'Verenigde Staten', region: 'California' },
  'florida': { country: 'Verenigde Staten', region: 'Florida' },
  'hawaii': { country: 'Verenigde Staten', region: 'Hawaii' },
  'new york': { country: 'Verenigde Staten', region: 'New York' },
  'patagonia': { country: 'Argentinië', region: 'Patagonia' },
  'patagonie': { country: 'Argentinië', region: 'Patagonia' },
  'atacama': { country: 'Chili', region: 'Atacama' },
  'guanacaste': { country: 'Costa Rica', region: 'Guanacaste' },
  'manuel antonio': { country: 'Costa Rica', region: 'Manuel Antonio' },
  // African regions
  'western cape': { country: 'Zuid-Afrika', region: 'Western Cape' },
  'kaapstad': { country: 'Zuid-Afrika', region: 'Western Cape' },
  'kruger': { country: 'Zuid-Afrika', region: 'Kruger' },
  'serengeti': { country: 'Tanzania', region: 'Serengeti' },
  'ngorongoro': { country: 'Tanzania', region: 'Ngorongoro' },
  'masai mara': { country: 'Kenia', region: 'Masai Mara' },
  'amboseli': { country: 'Kenia', region: 'Amboseli' }
};
